import React from "react";
import { Container, Card } from "react-bootstrap";
import { HotelImagesBrowser } from "./LeadTeamPortal";

export default function HotelImagesPage({ team }) {
  const storageKey = team === "CALL" ? "callTeamToken" : "chatTeamToken";
  const token = localStorage.getItem(storageKey);

  return (
    <Container fluid className="py-3 px-2 px-sm-3">
      <h4 className="mb-3">Hotel Images &amp; Videos</h4>
      {!token ? (
        <Card body className="text-center text-muted">
          Please log in to the {team === "CALL" ? "Call" : "Chat"} Team portal in another tab first, then reopen this page.
        </Card>
      ) : (
        <HotelImagesBrowser team={team} token={token} />
      )}
    </Container>
  );
}
